import { useState, useEffect } from 'react';
import { LandingPage, User } from '../types';
import { UserService } from '../services/userService';

export interface UseUsersCacheReturn {
  usersCache: Record<string, User>;
  loading: boolean;
}

/**
 * サイト一覧から必要なユーザー情報を取得してキャッシュする
 * @param sites - サイト一覧
 * @returns ユーザーキャッシュとローディング状態
 */
export const useUsersCache = (sites: LandingPage[]): UseUsersCacheReturn => {
  const [usersCache, setUsersCache] = useState<Record<string, User>>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadUsers = async () => {
      // 必要なユーザーIDを収集
      const userIds = new Set<string>();
      sites.forEach(site => {
        if (site.companyUserId) userIds.add(site.companyUserId);
        if (site.createdByUserId) userIds.add(site.createdByUserId);
        if (site.updatedByUserId) userIds.add(site.updatedByUserId);
      });

      if (userIds.size > 0) {
        try {
          setLoading(true);
          const usersData = await UserService.getUsers();
          const usersMap: Record<string, User> = {};
          usersData.forEach(user => {
            if (userIds.has(user.id)) {
              usersMap[user.id] = user;
            }
          });
          setUsersCache(usersMap);
        } catch (error) {
          console.error('ユーザー情報の取得に失敗しました:', error);
          setUsersCache({});
        } finally {
          setLoading(false);
        }
      } else {
        setUsersCache({});
      }
    };

    if (sites.length > 0) {
      loadUsers();
    } else {
      setUsersCache({});
    }
  }, [sites]);

  return { usersCache, loading };
};

